<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div
            class="flex items-center h-20 p-6 pb-0"
            style="cursor: pointer"
            (click)="navigateToHome()"
        >
        <ng-container *ngIf="company_logo || company_name">
            <ng-container *ngIf="company_logo">
              <img [src]="company_logo | minio" alt="Company Logo" class="company-logo" style="max-height: 100%; width: auto;">
            </ng-container>

            <ng-container *ngIf="!company_logo && company_name">
              <span>{{ company_name }}</span>
            </ng-container>
          </ng-container>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!--            <languages></languages>-->
            <!--            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
            <!--            <search [appearance]="'bar'"></search>-->
            <!--            <shortcuts></shortcuts>-->
            <!--            <messages></messages>-->
            <!--            <notifications></notifications>-->
            <!--            <button-->
            <!--                class="lg:hidden"-->
            <!--                mat-icon-button-->
            <!--                (click)="quickChat.toggle()">-->
            <!--                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>-->
            <!--            </button>-->
            <!--            <user></user>-->
            <!--            这里是登出的按钮 - 登出是清楚f12里的jwt token-->
            <button mat-menu-item (click)="signOut()">
                <mat-icon
                    [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
                ></mat-icon>
            </button>
        </div>
    </div>

    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--    <div-->
    <!--        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">-->
    <!--        <span class="font-medium text-secondary">Fuse &copy; {{ currentYear }}</span>-->
    <!--    </div>-->
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
